import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function ProtectedRoute({ children, requireAdmin = false }) {
  const { loading, isAuthed, isAdmin } = useAuth();
  const location = useLocation();

  /* ================================
     🔄 LOADING STATE (BETTER UI)
  ================================ */
  if (loading) {
    return (
      <div style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8fafc",
        fontSize: "16px",
        color: "#64748b"
      }}>
        Checking authentication...
      </div>
    );
  }

  /* ================================
     🚫 NOT LOGGED IN
  ================================ */
  if (!isAuthed) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }} // 🔥 remember where user came from
      />
    );
  }

  /* ================================
     🚫 NOT ADMIN
  ================================ */
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  /* ================================
     ✅ ACCESS GRANTED
  ================================ */
  return children;
}

export default ProtectedRoute;